import React, { FC, ReactNode } from "react";
import classNames from "classnames";
import { ITouchEvent, View } from "@tarojs/components";
import { XHComponentCommonProps } from "../../types";

import "./index.scss";

export type PasswordInputProps = {
  value: string;
  length: number;
  mask?: boolean;
  onFocus?: (e) => void;
} & XHComponentCommonProps;

const PasswordInput: FC<PasswordInputProps> = (props) => {
  const { value, length, mask = true, onFocus, className } = props;

  function renderInputs(): ReactNode {
    const Inputs: any = [];

    for (let i = 0; i < length; i++) {
      const char = value[i];

      Inputs.push(
        <View key={i} className="xh-password-input-item">
          {mask ? (
            <View className={classNames({ "xh-password-input-mask": char })} />
          ) : (
            char
          )}
        </View>
      );
    }

    return Inputs;
  }

  function handlerClick(e: ITouchEvent): void {
    e.stopPropagation();
    onFocus && onFocus(e);
  }
  const xhpasswordcls = classNames("xh-password-input", className);

  return (
    <View className={xhpasswordcls}>
      <View className="xh-password-input-list" onClick={handlerClick}>
        {renderInputs()}
      </View>
    </View>
  );
};

export default PasswordInput;
